<template>
    <el-container style="width:100%">
        <el-header style="height:120px;">
            <el-form :inline="true" :model="fromWorkFlow" ref="fromWorkFlow" class="demo-form-inline">
                <el-row :gutter="13">
                    <td-permission :permissions="permissionsView">
                        <div slot="havePermission">
                            <el-col>
                                <el-form-item :label="$t('pgCommon.WORK_FLOW_CAPTION')" prop="templateName">
                                    <td-input v-model="fromWorkFlow.templateName" :maxlength="100"></td-input>
                                </el-form-item>
                                <el-form-item :label="$t('pgCommon.PRODEFKEY')" prop="templateKey">
                                    <td-input v-model="fromWorkFlow.templateKey" :maxlength="100"></td-input>
                                </el-form-item>
                                <el-form-item :label="$t('pgCommon.TEMPLETSTATE')" prop="templateState">
                                    <td-select v-model="fromWorkFlow.templateState" :options="options"></td-select>
                                </el-form-item>
                            </el-col>
                        </div>
                    </td-permission>
                    <el-col>
                        <td-permission :permissions="permissionsView">
                            <div slot="havePermission">
                                <el-form-item :label="$t('pgCommon.UPDATETIME')" prop="date">
                                    <td-date-time v-model="fromWorkFlow.startTime" type="datetime" :pickerOptions="pickerBeginDateBefore" :placeholder="$t('pgCommon.START_TIME')"> </td-date-time>
                                </el-form-item>
                                <el-form-item :label="$t('pgCommon.UNTIL')">
                                    <td-date-time v-model="fromWorkFlow.endTime" type="datetime" :pickerOptions="pickerBeginDateAfter" :placeholder="$t('pgCommon.END_TIME')"> </td-date-time>
                                </el-form-item>
                            </div>
                        </td-permission>
                        <el-form-item>
                            <td-button type="primary" :permissions="permissionsView" :loading="loading" @click="btnQuery">{{ $t('pgCommon.QUERY') }}</td-button>
                            <td-button type="button" :permissions="permissionsEdit" @click="add">{{ $t('pgCommon.ADD') }}</td-button>
                            <td-button type="button" :permissions="permissionsImport" @click="btnImport">{{ $t('pgCommon.IMPORT') }}</td-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :columns="columns"
                :permissions="permissionsView"
                :hasMutiSelect="false"
                :dataSource="tableData"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :total="total"
                :rowKey="rowKey"
                ref="fromWorkFlowList"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
            ></td-table>
            <!-- 加载dialog -->
            <dialog-UploadInfo
                v-if="dialogUploadInfoVisible"
                :dialogUploadInfoVisible="dialogUploadInfoVisible"
                :listProInfo="listProInfo"
                :listCsmInfo="listCsmInfo"
                :title="title"
                @uploadDialogClose="uploadDialogClose"
                @submit="submit"
            ></dialog-UploadInfo>
            <!-- 加载dialog -->
            <setting-dialog
                v-if="settingDialogVisible"
                :settingDialogVisible="settingDialogVisible"
                :templateParam="templateParam"
                :listNodeInfo="listNodeInfo"
                :title="title"
                @settingDialogClose="settingDialogClose"
                @submit="submit"
            ></setting-dialog>
        </el-main>
    </el-container>
</template>

<script>
import Api from './assets/api.js';
import uploadInfoDialog from './components/uploadInfoDialog.vue';
import settingDialog from './components/settingDialog.vue';
export default {
    // 初始化渲染
    components: {
        'dialog-UploadInfo': uploadInfoDialog,
        'setting-dialog': settingDialog
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.btnQuery(); // 进行页面初始化数据的加载
    },
    // 监听时间
    watch: {
        ['fromWorkFlow.startTime'](val) {
            let dateVal = this.fromWorkFlow.endTime;
            if (
                dateVal &&
                val &&
                new Date(val).getTime() >
                    new Date(
                        dateVal
                            .replace(/-/g, '/')
                            .replace(/T|Z/g, ' ')
                            .trim()
                    ).getTime()
            ) {
                this.fromWorkFlow.endTime = val;
            }
        },
        ['fromWorkFlow.endTime'](val) {
            let dateVal = this.fromWorkFlow.startTime;
            if (
                dateVal &&
                val &&
                new Date(
                    dateVal
                        .replace(/-/g, '/')
                        .replace(/T|Z/g, ' ')
                        .trim()
                ).getTime() > new Date(val).getTime()
            ) {
                this.fromWorkFlow.startTime = val;
            }
        }
    },
    // 定义数据
    data() {
        return {
            pickerOptions1: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            permissionsAdd: ['workflow:add'],
            permissionsEdit: ['workflow:edit'],
            permissionsView: ['workflow:view'],
            permissionsDel: ['workflow:del'],
            permissionsImport: ['workflow:import'],
            listNodeInfo: [],
            templateKey: '',
            multipleSelection: null,
            fromWorkFlow: { templateName: '', templateKey: '', templateState: '', startTime: '', endTime: '' },
            dialogUploadInfoVisible: false, // 是否显示dialog
            settingDialogVisible: false, //是否显示设置界面dialog
            templateParam: {},
            tableData: [], // 表格数据
            startTime: '', // 查询开始时间
            endTime: '', // 查询结束时间
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            rowKey: 'deploymentId',
            // 初始化表格
            columns: [
                {
                    prop: 'templateKey',
                    label: 'pgCommon.PRODEFKEY',
                    align: 'left'
                },
                {
                    prop: 'templateName',
                    label: 'pgCommon.WORK_FLOW_CAPTION',
                    align: 'left'
                },
                // {
                //     prop: 'version',
                //     label: 'pgCommon.VERSION',
                //     align: 'center'
                // },
                {
                    prop: 'deploymentTime',
                    label: 'pgCommon.UPDATETIME',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('span', params.row.deploymentTime);
                    }
                },
                {
                    prop: 'suspensionState',
                    label: 'pgCommon.TEMPLETSTATE',
                    align: 'center',
                    render: (createElement, params) => {
                        if (params.row.suspensionState === this.$common.suspensionState.RUN) {
                            return createElement('span', this.$t('pgCommon.ISUSING'));
                        }
                        return createElement('span', this.$t('pgCommon.UNUSING'));
                    }
                },
                {
                    label: 'pgCommon.OPERATE',
                    align: 'center',
                    render: (createElement, params) => {
                        let isDisabled = false;
                        if (params.row.suspensionState === '1') {
                            isDisabled = true;
                        }
                        let operateList = [
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.edit(params.row.modelId);
                                        }
                                    }
                                },
                                this.$t('pgCommon.EDIT')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsDel, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.delete(params.row.templateKey);
                                        }
                                    }
                                },
                                this.$t('pgCommon.DELETE')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsDel, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.exportModel(params.row.deploymentId, params.row.resourceName, params.row.templateName, params.row.modelId);
                                        }
                                    }
                                },
                                this.$t('pgCommon.EXPORT')
                            )
                        ];
                        let status;
                        if (isDisabled) {
                            status = createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small', disabled: !isDisabled },
                                    on: {
                                        click: () => {
                                            this.stopEnabled(params.row.templateId);
                                        }
                                    }
                                },
                                this.$t('pgCommon.STOPENABLED')
                            );
                        } else {
                            status = createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small', disabled: isDisabled },
                                    on: {
                                        click: () => {
                                            this.immediatelyEnable(params.row.templateId);
                                        }
                                    }
                                },
                                this.$t('pgCommon.IMMEDIATELYENABLED')
                            );
                        }
                        operateList.push(status);
                        operateList.push(
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.seting(params.row);
                                        }
                                    }
                                },
                                this.$t('pgCommon.SETING')
                            )
                        );
                        return operateList;
                    }
                }
            ],
            // 对表单进行数据验证
            rules: {
                templateName: [
                    {
                        pattern: this.$regex.CAPTION_RULE,
                        message: this.$t('error.ERROR_USER_CAPTION_ILLEGAL')
                    }
                ],
                templateKey: [
                    {
                        pattern: this.$regex.CAPTION_RULE,
                        message: this.$t('error.ERROR_USER_CAPTION_ILLEGAL')
                    }
                ]
            },
            // 运行状态下拉列表
            options: [
                {
                    value: '1',
                    label: this.$t('pgCommon.ISUSING')
                },
                {
                    value: '2',
                    label: this.$t('pgCommon.UNUSING')
                }
            ],
            pickerBeginDateBefore: {
                disabledDate: time => {
                    let dateVal = this.fromWorkFlow.endTime;
                    if (dateVal) {
                        return (
                            time.getTime() >
                            new Date(
                                dateVal
                                    .replace(/-/g, '/')
                                    .replace(/T|Z/g, ' ')
                                    .trim()
                            ).getTime()
                        );
                    }
                }
            },
            pickerBeginDateAfter: {
                disabledDate: time => {
                    let dateVal = this.fromWorkFlow.startTime;
                    if (dateVal) {
                        return (
                            time.getTime() <=
                            new Date(
                                dateVal
                                    .replace(/-/g, '/')
                                    .replace(/T|Z/g, ' ')
                                    .trim()
                            ).getTime() -
                                8.64e7
                        );
                    }
                }
            }
        };
    },
    // 方法的实现
    methods: {
        // 根据upload的id显示对应的类型名称
        formatterType(row) {
            switch (row.iType) {
                case 0:
                    return this.$t('pgCommon.RABBITupload');
                default:
                    return this.$t('pgCommon.UNKNOW_TYPE');
            }
        },

        getStartTime(val) {
            this.startTime = this.dateFilter(val);
        },

        getEndTime(val) {
            this.endTime = this.dateFilter(val);
        },
        // 处理时间格式
        dateFilter(input) {
            let d = new Date(input);
            let year = d.getFullYear();
            let month = d.getMonth() + 1;
            let day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate();
            let date = year + '-' + month + '-' + day;
            return date;
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.queryList();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.queryList();
        },
        // 查询数据
        btnQuery() {
            this.loading = true;
            this.currentPage = 1;
            this.queryList();
        },
        queryList() {
            this.loading = true;
            let param = {
                templateName: this.fromWorkFlow.templateName,
                templateKey: this.fromWorkFlow.templateKey,
                templateState: this.fromWorkFlow.templateState,
                startTime: this.fromWorkFlow.startTime,
                endTime: this.fromWorkFlow.endTime,
                updateTime: '',
                currentPage: this.currentPage,
                pageSize: this.pageSize,
                isNeedPage: true
            };
            Api.queryTemplate(JSON.stringify(param), response => {
                this.loading = false;
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.loading = false;
                    this.$log.error('templateManage/queryTemplate', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.loading = false;
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.$log.error('templateManage/queryTemplate', response.data.message);
                    return;
                }
                this.loading = false;
                this.tableData = response.data.content;
                this.total = response.data.count;
            });
        },
        // 删除接口
        btnDelete() {
            this.multipleSelection = this.$refs.fromWorkFlowList.getSelectAllRows();
            this.$log.error(this.multipleSelection);
            if (this.multipleSelection.length === 0) {
                this.$message({ type: 'warning', showClose: true, message: this.$t('message.PLEASE_CHOOSE_DELETE_TEMPLATE') });
                return;
            }
            let deploymentId = [];
            for (let i = 0; i < this.multipleSelection.length; i++) {
                deploymentId.push(this.multipleSelection[i].deploymentId);
            }
            this.delete(deploymentId);
        },
        // 立即启用
        immediatelyEnable(deploymentIds) {
            this.$confirm(this.$t('pgCommon.IMMEDIATELYE_NABLED_TIP'), this.$t('pgCommon.TIPS'), {
                confirmButtonText: this.$t('pgCommon.SURE'),
                cancelButtonText: this.$t('pgCommon.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let param = { templateIds: deploymentIds, caseCade: false };
                    Api.immediatelyEnable(JSON.stringify(param), response => {
                        if (response.data.ret !== this.$common.requestCode.SUCCESS) {
                            this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                            this.$log.error('templateManage/immediatelyEnable', response.data.message);
                            return;
                        }
                        this.multipleSelection = null;
                        this.$message({ type: 'success', showClose: true, message: this.$t('pgCommon.ENABLED_SUCCESS') });
                        this.btnQuery();
                    });
                })
                .catch(() => {});
        },
        // 停止启用
        stopEnabled(deploymentIds) {
            this.$confirm(this.$t('pgCommon.STOP_NABLED_TIP'), this.$t('pgCommon.TIPS'), {
                confirmButtonText: this.$t('pgCommon.SURE'),
                cancelButtonText: this.$t('pgCommon.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let param = { templateIds: deploymentIds, caseCade: false };
                    Api.stopEnabled(JSON.stringify(param), response => {
                        if (response.data.ret !== this.$common.requestCode.SUCCESS) {
                            this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                            this.$log.error('templateManage/stopEnabled', response.data.message);
                            return;
                        }
                        this.multipleSelection = null;
                        this.$message({ type: 'success', showClose: true, message: this.$t('pgCommon.STOP_SUCCESS') });
                        this.btnQuery();
                    });
                })
                .catch(() => {
                    this.$log.error('templateManage/stopEnabled---- Fail');
                });
        },
        // 删除
        delete(templateKey) {
            this.$confirm(this.$t('pgCommon.DELETE_TEMPLATE_INFO_TIPS'), this.$t('pgCommon.TIPS'), {
                cancelButtonText: this.$t('pgCommon.CANCEL'),
                confirmButtonText: this.$t('pgCommon.SURE'),
                type: 'warning'
            })
                .then(() => {
                    let param = { proDefKey: templateKey };
                    Api.deleteTemplate(JSON.stringify(param), response => {
                        this.templateId = [];
                        if (response.status !== this.$common.login.RESPONSE_STATUS) {
                            this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                            this.loading = false;
                            this.$log.error('templateManage/queryTemplate', response);
                            return;
                        }
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.loading = false;
                            this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                            this.$log.error('templateManage/queryTemplate', response.data.message);
                            return;
                        }
                        this.multipleSelection = null;
                        this.$message({ type: 'success', showClose: true, message: this.$t('pgCommon.DELETE_SUCCESS') });
                        this.btnQuery();
                    });
                })
                .catch(() => {
                    this.$log.error('templateManage/delete---- Fail');
                });
        },
        // 编辑
        add() {
            let _this = this;
            Api.newModel('', response => {
                if (response.data.ret !== this.$common.requestCode.SUCCESS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.$log.error('templateManage/immediatelyEnable', response.data.message);
                    return;
                }
                if (response.data == null) {
                    this.loading = false;
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.$log.error('templateManage/queryTemplate', response.data.message);
                    return;
                }
                //如果成功，则读取后端返回的操作指令
                let result = response.data;
                if (result['msg']) {
                    alert(result.msg);
                }
                //刷新
                if (result['refresh']) {
                    window.location.reload();
                    return;
                }
                //返回
                if (result['back']) {
                    window.location.href = document.referrer;
                }
                //跳转
                if (result['redirectUrl'] != null) {
                    let winObj = window.open(
                        window.config.host + '/' + result.redirectUrl,
                        '',
                        'width=' + (window.screen.availWidth - 10) + ',height=' + (window.screen.availHeight - 60) + ',top=0,left=0,Toolbar=no,location=no,resizable=yes'
                    );
                    let loop = setInterval(function() {
                        if (winObj.closed) {
                            clearInterval(loop);
                            _this.btnQuery();
                        }
                    }, 1000);
                    return;
                }
                return result.data;
            });
        },
        //编辑
        edit(templateId) {
            let _this = this;
            let winObj = window.open(
                window.config.host + '/' + 'modeler.html?modelId=' + templateId,
                '',
                'width=' + (window.screen.availWidth - 10) + ',height=' + (window.screen.availHeight - 60) + ',top=0,left=0,Toolbar=no,location=no,resizable=yes'
            );
            let loop = setInterval(function() {
                if (winObj.closed) {
                    clearInterval(loop);
                    _this.btnQuery();
                }
            }, 1000);
        },
        //导出
        exportModel(deploymentId, resourceName, templateName, modelId) {
            let param = {
                deploymentId: deploymentId,
                resourceName: resourceName,
                templateName: templateName,
                modelId: modelId
            };
            Api.exportModel(JSON.stringify(param), response => {
                let blob = new Blob(['\ufeff' + response.data], { type: 'text/html;charset=UTF-8' });
                this.content = response.data;
                this.epLoading = false;
                // 汉字解码
                let filename = decodeURIComponent(response.headers['filename']);
                if (window.navigator.msSaveOrOpenBlob) {
                    // 兼容IE10
                    navigator.msSaveBlob(blob, filename);
                } else {
                    //  chrome/firefox
                    let aTag = document.createElement('a');
                    aTag.download = filename;
                    aTag.href = window.URL.createObjectURL(blob);
                    aTag.click();
                    URL.revokeObjectURL(aTag.href);
                }
            });
        },
        // 导入
        btnImport() {
            this.title = 'pgCommon.IMPORT'; // 标题
            this.dialogUploadInfoVisible = true;
        },
        // 批量停用
        btnStopEnable() {
            this.multipleSelection = this.$refs.fromWorkFlowList.getSelectAllRows();
            this.$log.error(this.multipleSelection);
            if (this.multipleSelection.length === 0) {
                this.$message({ type: 'warning', showClose: true, message: this.$t('message.PLEASE_CHOOSE_TEMPLATE') });
                return;
            }
            let templateIds = [];
            for (let i = 0; i < this.multipleSelection.length; i++) {
                if (this.multipleSelection[i].suspensionState === '1') {
                    templateIds.push(this.multipleSelection[i].templateId);
                }
            }
            this.stopEnabled(templateIds);
        },
        // 批量启用
        btnImmediatelyEnable() {
            this.multipleSelection = this.$refs.fromWorkFlowList.getSelectAllRows();
            if (this.multipleSelection.length === 0) {
                this.$message({ type: 'warning', showClose: true, message: this.$t('message.PLEASE_CHOOSE_TEMPLATE') });
                return;
            }
            let templateIds = [];
            for (let i = 0; i < this.multipleSelection.length; i++) {
                if (this.multipleSelection[i].suspensionState === '2') {
                    templateIds.push(this.multipleSelection[i].templateId);
                }
            }
            this.immediatelyEnable(templateIds);
        },
        // 用户，操作按钮设置
        seting(param) {
            this.title = 'pgCommon.SETING'; // 标题
            this.templateParam = param;
            this.settingDialogVisible = true;
        },
        // 关闭上传界面
        uploadDialogClose() {
            this.dialogUploadInfoVisible = false;
            this.queryList();
        },
        // 关闭设置界面
        settingDialogClose() {
            this.settingDialogVisible = false;
        }
    }
};
</script>
<style scoped>
.btnStyle {
    margin-left: 100px;
}
</style>
